<template>
  <div>
    <a-auto-complete v-model:value="name" :options="dataSource" backfill allowClear>
      <a-input
        v-model:value="name"
        placeholder="请输入或选择单位名称"
        :maxlength="200"
        autocomplete="off"
        style="width: 100%"
        @change="onSelectName"
      >
        <!-- <template #prefix>
          <div class="password__prefix">
            <img src="./../../../../../assets/images/company.png" />
          </div>
        </template> -->
      </a-input>
      <template #option="item">
        <div @click="onChange(item)">{{ item.companyName }}</div>
      </template>
    </a-auto-complete>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, watch, onMounted, reactive, toRefs } from "vue";
import { CompanyService } from "@/views/cooperation/company/company.service";
// import { useThrottleFn } from "@vueuse/core";
export default defineComponent({
  name: "ParticipantsCreateName",
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
  },
  emit: ["update:value", "update:id", "change", "clear"],
  setup(props, { emit }) {
    const state = reactive({
      name: "",
    });

    const { data: dataSource, loading, run, refresh, pagination } = CompanyService.usePageApi();

    const onChange = (v) => {
      state.name = v.companyName;

      emit("update:value", v.companyName);
      emit("update:id", v.id);
      emit("change", v);
    };

    const onSelectName = async () => {
      
      await run({
        current: 1,
        size: 20,
        sortBy: "id",
        sortOrder: "desc",
        companyName: state.name,
        cooperationCompanyTypeIds: "",
      });
      
      const { id } = dataSource?.value?.find((item) => item.companyName == state.name) || {
        id: "",
      };
      emit("update:value", state.name);
      emit("update:id", id);
    };

    const onClear = () => {
      emit("update:value", undefined);
      emit("update:id", undefined);
      emit("clear", undefined);
    };
    watch(
      () => props.value,
      async (n, o) => {
        if (!n) {
          state.name = "";
        }
      },
      { immediate: true }
    );
    onMounted(async () => {
      await run({
        current: 1,
        size: 20,
        sortBy: "id",
        sortOrder: "desc",
        companyName: state.name,
        cooperationCompanyTypeIds: "",
      });
    });
    return {
      ...toRefs(state),
      dataSource,
      onSelectName,
      onChange,
      onClear,
    };
  },
});
</script>
